import { KampaayDataProvider } from 'services/api/dataProvider'
import { Food } from 'services/api/entities/catalog/food/types/internal/food-models'
import { getName } from 'services/utils'
import {
  parseCsvFields,
  parseMultilangUpsellingNames,
} from 'services/utils/multilangParseWrite'
import { EntityDescriptor } from '.'
import { formatOptions, formatHighlights, formatPriceRange } from './common'

export const foods: EntityDescriptor<Food> = {
  format: (_dataProvider?: KampaayDataProvider) => (record) => {
    const {
      images,
      upsellingItems,
      upsellingItemsFull,
      pricing,
      logistics,
      logisticsFull,
      name,
      description,
      highlights,
      advanceReservationMin,
      ...rest
    } = record
    const logisticsFullNames = logisticsFull.map(getName)
    return {
      ...rest,
      highlights: formatHighlights(highlights),
      ...parseCsvFields({ name, description }),
      'Booking time-limit': advanceReservationMin,
      'Logistics Names': logisticsFullNames,
      upselling: parseMultilangUpsellingNames(record.upsellingItemsFull),
      options: formatOptions(record.options),
      pricing: pricing.map(formatPriceRange),
    }
  },
}
